import moment from "moment";

export default {

    computed: {
        maxDate() {
            return moment().format('YYYY-MM-DD');
        },
    },

    methods: {
        hasError(name) {
            return this.$store.getters.hasError(name)
        },

        getError(name) {
            return this.$store.getters.getError(name)
        }
    },

    watch: {
        expense: {
            deep: true,
            handler(val) {
                this.$emit('input', val);
            }
        },
    }

}